// extracted by mini-css-extract-plugin
export default {"wrapper":"mn-z","viewport":"nn-z","container":"on-z","slide":"pn-z"};